<template>
  <div class="alb">
    <!-- ═══ MODO LISTADO ═══ -->
    <div v-if="modoAlbaran" class="alb__main">

      <!-- Toolbar superior -->
      <div class="alb__toolbar">
        <div class="alb__toolbar-left">
          <button class="alb__btn alb__btn--secondary" @click="selectAll()">
            <i class="fa-solid fa-check-double"></i> Select All
          </button>
          <button class="alb__btn alb__btn--primary" @click="copiarSelect()">
            <i class="fa-solid fa-copy"></i> Copiar
          </button>
        </div>

        <button class="alb__btn-fab" @click="modoAlbaran = false" v-b-tooltip.hover.v-success title="Crear nuevo">
          <i class="fa-solid fa-plus"></i>
        </button>

        <div class="alb__toolbar-right">
          <button class="alb__btn alb__btn--outline" @click="editarPrecios()">
            <i class="fa-solid fa-tags"></i> Precios Sku
          </button>
        </div>
      </div>

      <!-- Filtros -->
      <div class="alb__filters">
        <div class="alb__filter-item">
          <label class="alb__filter-label">Estado</label>
          <v-select v-model="estadoSelect" :options="['Todos', 'Pendiente', 'Facturado']" :clearable="false"
            placeholder="Seleccionar" class="alb__filter-select" />
        </div>

        <div class="alb__filter-item">
          <label class="alb__filter-label">Desde</label>
          <div class="alb__date-wrap">
            <flat-pickr v-model="fechaDesdeSelect" class="form-control alb__date-input" />
            <button class="alb__date-clear" @click="fechaDesdeSelect = ''" title="Limpiar">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>

        <div class="alb__filter-item">
          <label class="alb__filter-label">Hasta</label>
          <div class="alb__date-wrap">
            <flat-pickr v-model="fechaHastaSelect" class="form-control alb__date-input" />
            <button class="alb__date-clear" @click="fechaHastaSelect = ''" title="Limpiar">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>

        <div class="alb__filter-actions">
          <button class="alb__btn-icon alb__btn-icon--primary" @click="seleccionarTodos()"
            v-b-tooltip.hover.v-primary title="Seleccionar todos">
            <i class="fa-solid fa-check"></i>
          </button>
          <button class="alb__btn-icon alb__btn-icon--warning" @click="limpiarSeleccionados()"
            v-b-tooltip.hover.v-warning title="Limpiar seleccionados">
            <i class="fa-solid fa-eraser"></i>
          </button>
        </div>

        <div class="alb__filter-toggle">
          <b-form-checkbox id="checkbox-1" v-model="agruparCheck" name="checkbox-1" switch>
            Agrupar
          </b-form-checkbox>
        </div>
      </div>

      <!-- Barra de seleccion + acciones -->
      <div v-if="!agruparCheck && cantidadCheck > 0" class="alb__selection-bar">
        <div class="alb__selection-info">
          <span class="alb__selection-badge">{{ cantidadCheck }}</span>
          seleccionados
          <span class="alb__selection-total">{{ totalCheck }} &euro;</span>
        </div>
        <div class="alb__selection-actions">
          <button class="alb__btn alb__btn--success" @click="facturarProductos()"
            v-b-tooltip.hover.v-success :title="'Facturar: ' + cantidadCheck">
            <i class="fa-solid fa-file-invoice-dollar"></i> Facturar
          </button>
          <button class="alb__btn alb__btn--primary" @click="pedirCodigo()"
            v-b-tooltip.hover.v-primary :title="'Manual: ' + cantidadCheck">
            <i class="fa-solid fa-pen-to-square"></i> Manual
          </button>
          <button class="alb__btn alb__btn--danger" @click="borrarButtonClick()"
            v-b-tooltip.hover.v-danger :title="'Borrar: ' + cantidadCheck">
            <i class="fa-solid fa-trash"></i> Borrar
          </button>
        </div>
      </div>

      <!-- Buscador -->
      <div class="alb__search">
        <i class="fa-solid fa-magnifying-glass alb__search-icon"></i>
        <input type="text" class="alb__search-input" placeholder="Buscar por SKU..." v-model="buscar" />
      </div>

      <!-- Tabla principal -->
      <div class="alb__table-card">
        <b-table :items="articulosBusqueda" :fields="columnasTable" class="alb__table" no-border-collapse
          sort-icon-left @sort-changed="sortChanged" ref="table" hover thead-class="alb__thead"
          primary-key="id">

          <template #cell(check)="data">
            <b-form-checkbox v-model="data.item.check" @change="itemCheck"></b-form-checkbox>
          </template>

          <template #cell(sku)="data">
            <span class="alb__sku" @click="rowClick(data.item)">{{ data.item.sku }}</span>
          </template>

          <template #cell(cantidad)="data">
            <span class="alb__cantidad" v-if="!data.item.editando" @click="editandoCantidad(data.item)">
              {{ data.item.cantidad }}
            </span>
            <div v-if="data.item.editando" class="alb__cantidad-edit">
              <input type="text" v-model="data.item.cantidad" class="alb__cantidad-input">
              <button class="alb__cantidad-save" @click="guardarCantidad(data.item)">
                <i class="fa-solid fa-floppy-disk"></i>
              </button>
            </div>
          </template>

          <template #cell(img)="data">
            <img v-if="data.item.image" :src="data.item.image" class="alb__img" alt="">
          </template>

          <template #cell(factura)="data">
            <span v-if="data.item.factura" class="alb__badge alb__badge--facturado">{{ data.item.factura }}</span>
            <span v-else class="alb__badge alb__badge--pendiente">Pendiente</span>
          </template>

        </b-table>
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
      </div>

      <!-- Modal agregar -->
      <b-modal id="modal-add" :title="tituloModal" centered size="xl" hide-footer modal-class="alb__modal">
        <div v-if="false">
          <b-row class="match-height">
            <b-col cols="7">
              <b-form-group label="Sku" label-for="basicInput">
                <v-select v-model="inputSku" class="sku-select" label="sku" :options="articulos" />
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Cantidad" label-for="basicInput">
                <b-form-input id="basicInput" placeholder="cantidad" v-model="inputCantidad" type="number" @wheel.prevent />
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group label="Fecha" label-for="basicInput">
                <b-form-datepicker v-model="inputFecha" class="mb-2" today-button placeholder="fecha"
                  :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }" locale="es"></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group v-if="inputSku != null && inputSku.shopify_product_id == -1" label="Titulo" label-for="basicInput">
                <b-form-input id="basicInput" placeholder="titulo" v-model="inputTitulo" />
              </b-form-group>
            </b-col>
          </b-row>
          <div class="text-center" style="height: 300px">
            <img v-if="inputSku != null" :src="inputSku.image" style="max-height: 300px" alt="">
          </div>
        </div>
        <div v-else>
          <b-table :items="articulosAddMore" :fields="columnasAddMore" class="alb__table alb__table--add" no-border-collapse
            sort-icon-left ref="tableAddMore" hover thead-class="alb__thead">

            <template #cell(_img)="data">
              <img v-if="data.item.sku != null && data.item.sku.image" :src="data.item.sku.image" class="alb__img alb__img--lg" alt="">
            </template>

            <template #cell(_sku)="data">
              <v-select v-model="data.item.sku" label="sku" :options="articulos" />
              <b-form-input class="mt-50" v-if="data.item.sku != null && data.item.sku.shopify_product_id == -1"
                placeholder="titulo" v-model="data.item.titulo" />
            </template>

            <template #cell(_cantidad)="data">
              <b-form-input placeholder="cantidad" v-model="data.item.cantidad" type="number" @wheel.prevent />
            </template>

            <template #cell(_fecha)="data">
              <b-form-datepicker v-model="data.item.fecha" class="mb-0" today-button placeholder="fecha"
                :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }" locale="es"></b-form-datepicker>
            </template>

            <template #cell(_opt)="data">
              <button class="alb__btn-icon alb__btn-icon--danger" @click="deleteLineAddMore(data.index)">
                <i class="fa-solid fa-minus"></i>
              </button>
            </template>

          </b-table>

          <div class="alb__add-actions">
            <button class="alb__btn alb__btn--primary" @click="addMore()">
              <i class="fa-solid fa-plus"></i> Agregar mas
            </button>
          </div>
        </div>

        <div class="alb__add-actions" style="margin-top: 16px">
          <button class="alb__btn alb__btn--success" @click="guardarPendiente()">
            <i class="fa-solid fa-floppy-disk"></i> {{ textBotonGuardar }}
          </button>
        </div>
      </b-modal>
    </div>

    <!-- ═══ MODO AGREGAR ═══ -->
    <div v-else class="alb__main">
      <div class="alb__toolbar">
        <button class="alb__btn alb__btn--secondary" @click="modoAlbaran = true">
          <i class="fa-solid fa-chevron-left"></i> Volver
        </button>
        <div class="alb__toolbar-title">
          <i class="fa-solid fa-plus-circle"></i> Nuevo Albaran
        </div>
        <div></div>
      </div>

      <div class="alb__table-card">
        <b-table :items="articulosAddMore" :fields="columnasAddMore" class="alb__table alb__table--add" no-border-collapse
          sort-icon-left ref="tableAddMore" hover thead-class="alb__thead">

          <template #cell(_img)="data">
            <img v-if="data.item.sku != null && data.item.sku.image" :src="data.item.sku.image" class="alb__img alb__img--lg" alt="">
          </template>

          <template #cell(_sku)="data">
            <v-select v-model="data.item.sku" label="sku" :options="articulos" />
            <b-form-input class="mt-50" v-if="data.item.sku != null && data.item.sku.shopify_product_id == -1"
              placeholder="titulo" v-model="data.item.titulo" />
          </template>

          <template #cell(_cantidad)="data">
            <b-form-input placeholder="cantidad" v-model="data.item.cantidad" type="number" @wheel.prevent />
          </template>

          <template #cell(_fecha)="data">
          <b-form-input placeholder="fecha" v-model="data.item.fecha" type="text" @wheel.prevent />
            <!--<b-form-datepicker v-model="data.item.fecha" class="mb-0" today-button placeholder="fecha"
              :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }" locale="es"></b-form-datepicker>-->
          </template>

          <template #cell(_opt)="data">
            <button class="alb__btn-icon alb__btn-icon--danger" @click="deleteLineAddMore(data.index)">
              <i class="fa-solid fa-minus"></i>
            </button>
          </template>
        </b-table>

        <div class="alb__add-footer">
          <button class="alb__btn alb__btn--primary" @click="addMore()">
            <i class="fa-solid fa-plus"></i> Agregar mas
          </button>
        </div>
      </div>

      <div class="alb__bottom-bar">
        <button class="alb__btn alb__btn--danger-outline" @click="limpiarAdd()">
          <i class="fa-solid fa-eraser"></i> Limpiar
        </button>
        <button class="alb__btn alb__btn--success" @click="guardarPendiente()">
          <i class="fa-solid fa-floppy-disk"></i> {{ textBotonGuardar }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@axios'
/*import VueApexCharts from 'vue-apexcharts'*/
import { BTable, BFormCheckbox, BFormInput, BFormGroup, BModal, BCardText, BCardBody, BCard, BRow, BCol } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import { $themeColors } from '@themeConfig'
import { useTimeout } from '@vueuse/shared'
import vSelect from 'vue-select'
import { forEach } from 'postcss-rtl/lib/affected-props'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BCardCode,
    BFormCheckbox,
    BTable,
    BFormInput,
    BFormGroup,
    BCardText,
    BCardBody,
    BCard,
    BRow,
    BCol,
    vSelect,
    flatPickr
  },
  data() {
    return {
      columnasAll: [
        {
          key: "check",
          label: "",
          sortable: false,
          thStyle: { width: "1%" },
        },
        {
          key: "img",
          label: "",
          sortable: false,
          thStyle: { width: "10%" },
        },
        {
          key: "cantidadMostrar",
          label: "Total",
          sortable: true,
          thStyle: { width: "5%" },
        },
         {
          key: "cantidad",
          label: "Cantidad",
          sortable: true,
          thStyle: { width: "5%" },
        },
         {
          key: "cantidadFacturada",
          label: "Facturada",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "sku",
          label: "SKU",
          sortable: true,
          thStyle: { width: "20%" },
        }, {
          key: "total",
          label: "Precio",
          sortable: true,
          thStyle: { width: "10%" },
        }, {
          key: "fechaTerminado",
          label: "Fecha",
          sortable: true,
          thStyle: { width: "10%" },
        }, {
          key: "factura",
          label: "Factura",
          sortable: true,
        }],
      articulos: [],
      anyo: 2022,
      buscar: "",
      countItemView: 30,
      nextScrollItemView: 20,
      defaultItemView: 30,
      watching: true,
      lastSort: null,
      anyoSelect: { nombre: "Todos", value: 'Todos', active: true },
      articulosBusqueda: [],
      columnasTable: [],
      listadoAnyos: [
        { nombre: "Todos", value: 'Todos', active: true },
        { nombre: "2024", value: 2024, active: true },
        { nombre: "2023", value: 2023, active: true },
      ],
      pedienteCheck: false,
      estadoSelect: 'Todos',
      inputSku: "",
      inputCantidad: "",
      textBotonGuardar: "Guardar",
      tituloModal: "Añadir producto",
      inputFecha: "",
      inputTitulo: "",
      listadoPendiente: [],
      articulosSku: [],
      totalCheck: 0,
      cantidadCheck: 0,
      esperandoCalcular: true,
      fechaDesdeSelect: '',
      fechaHastaSelect: '',
      agruparCheck: false,
      agregarMultiple: 1,
      columnasAddMore: [
        {
          key: "_img",
          label: "",
          sortable: false,
          thStyle: { width: "5%" },
        },
        {
          key: "_sku",
          label: "SKU",
          sortable: true,
          thStyle: { width: "20%" },
        },
        {
          key: "_cantidad",
          label: "Cantidad",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "_fecha",
          label: "Fecha",
          sortable: true,
          thStyle: { width: "10%" },
        },
        {
          key: "_opt",
          label: "",
          sortable: true,
          thStyle: { width: "5%" },
        }],
      articulosAddMore: [
        {
          image: '',
          sku: '',
          cantidad: '',
          fecha: ''
        }
      ],
      modoAlbaran: true
    }
  },
  methods: {
    loadItems() {
      this.cargarColumnas();

      axios.post("/uso", { seccion: "albaran" });

      //const requestArticulos = axios.get("/articulos/variants").then(response => response.data);
      const requestPendiente = axios.get("/finanzas/pendiente/facturar").then(response => response.data);
      const requestArticulosPrecios = axios.get("/finanzas/articulos").then(response => response.data);
      const fetchArticulosShopify = axios.get("/articulos/shopify").then(response => response.data);

      Promise.all([requestPendiente, requestArticulosPrecios, fetchArticulosShopify])
        .then(([resPendiente, resArticulosPrecios, resArticulosShopify]) => {

          this.articulos = Array.from(
            new Map(
              resArticulosShopify.flatMap(item =>
                item.variants
                  .filter(variant => variant.sku)
                  .map(variant => {
                    const image = item.images.find(img => img.id === variant.image_id) || {};
                    return {
                      sku: variant.sku,
                      precio: parseFloat(variant.price),
                      image: image.src || '',
                      shopify_product_id: variant.id
                    };
                  })
              ).map(articulo => [articulo.sku, articulo])
            ).values()
          );

          //console.log(this.articulos);

          //console.log(resArticulosShopify);
          this.articulosSku = resArticulosPrecios;

          this.articulos = this.articulos.filter(articulo => {
            let skuCortado = articulo.sku.replace(/-[^-]+$/, "");
            const articuloEncontrado = this.articulosSku.find(item => item.sku === skuCortado);

            return articuloEncontrado && Number(articuloEncontrado.confeccion) !== 0;
          });

          this.articulos = this.articulos.filter(x => !x.sku.includes("RPET-COMMUTER-BACKPACK-13"));

          this.articulos.push({ sku: "CLOTH-BAG-S", image: "https://cdn.shopify.com/s/files/1/0653/3919/files/Bolsa-tela-Harber-London.heic?v=1701255212", shopify_product_id: 999999 });
          this.articulos.push({ sku: "CLOTH-BAG-M", image: "https://cdn.shopify.com/s/files/1/0653/3919/files/Bolsa-tela-Harber-London.heic?v=1701255212", shopify_product_id: 999998 });
          this.articulos.push({ sku: "CLOTH-BAG-L", image: "https://cdn.shopify.com/s/files/1/0653/3919/files/Bolsa-tela-Harber-London.heic?v=1701255212", shopify_product_id: 999997 });
          this.articulos.push({ sku: "CLOTH-BAG-XL", image: "https://cdn.shopify.com/s/files/1/0653/3919/files/Bolsa-tela-Harber-London.heic?v=1701255212", shopify_product_id: 999996 });

          this.articulos.push({ sku: "otros", image: "", shopify_product_id: -1 });

          this.listadoPendiente = resPendiente;

          this.listadoPendiente.forEach(itemPendiente => {
            itemPendiente.cantidadMostrar = itemPendiente.cantidad + itemPendiente.cantidadFacturada;
            itemPendiente.check = false;
            itemPendiente.editando = false;
            const articuloCorrespondiente = this.articulos.find(itemArticulo => itemPendiente.sku === itemArticulo.sku);
            if (articuloCorrespondiente) {
              itemPendiente.image = articuloCorrespondiente.image;
            }

            let skuCortado = itemPendiente.sku.replace(/-[^-]+$/, "");

            if (itemPendiente.sku.includes('CLOTH-BAG'))
              skuCortado = itemPendiente.sku;

            const articuloEncontrado = this.articulosSku.filter(item => item.sku === skuCortado);

            function calcularTotal(articulo, cantidad) {
              let total;
              if (articulo.confeccion == 0 && articulo.ubrique != 0) {
                total = articulo.ubrique * cantidad;
              } else {
                total = articulo.confeccion * cantidad;
              }
              return parseFloat(total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
            }

            if (articuloEncontrado.length > 0) {
              itemPendiente.total = calcularTotal(articuloEncontrado[0], itemPendiente.cantidad);
            }
            else {

              if ((skuCortado.split('-').pop() == 'NOMAD') || (skuCortado.split('-').pop() == 'DOPP') || (skuCortado.includes('CARD-HOLDER-RFID-HOR'))) {
                let skuCortadoNomadDop = skuCortado.replace(/-[^-]+$/, "");

                const articuloEncontradoNomad = this.articulosSku.filter(item => item.sku === skuCortadoNomadDop);
                if (articuloEncontradoNomad.length > 0) {
                  itemPendiente.total = calcularTotal(articuloEncontradoNomad[0], itemPendiente.cantidad);
                }

              }
            }

          });

          this.buscarFuncion();
        })
        .catch(error => {
          console.error("Error en las solicitudes axios:", error);
        });

    },
    openModalNew() {
      const now = new Date();
      const day = now.getDate().toString().padStart(2, '0');
      let month = (now.getMonth() + 1).toString().padStart(2, '0');
      const year = now.getFullYear();

      this.inputFecha = `${year}-${month}-${day}`;

      this.articulosAddMore = [
        {
          image: '',
          sku: '',
          cantidad: '',
          fecha: ''
        }
      ];

      this.$bvModal.show('modal-add');

      setTimeout(() => {
        const elements = document.querySelectorAll('.vs__search');
        elements[elements.length - 1].focus();
      }, 100);
    },
    borrarButtonClick() {

      const confirmOptions = {
        showCancelButton: true,
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      };

      let cantidad = 0;

      this.listadoPendiente.forEach(item => {
        if (item.check)
          cantidad++;
      });


      if (cantidad == 0) {
        this.$swal({ title: "No hay productos seleccionados." });
      }
      else {

        let textoFinal = 'producto?'

        if (cantidad > 1)
          textoFinal = 'productos?'

        this.$swal({
          title: `¿Estas seguro que quieres borrar ${cantidad} ${textoFinal}`,
          icon: 'question',
          confirmButtonText: 'Si, borrar',
          ...confirmOptions,
        }).then(result => {
          if (result.value) {
            this.deleteProducto();
          }
        });

      }
    },
    deleteLineAddMore(index) {
      this.articulosAddMore.splice(index, 1);
    },
    addMore() {
      this.articulosAddMore.push(
        {
          image: '',
          sku: '',
          cantidad: '',
          fecha: ''
        }
      );

      setTimeout(() => {
        const elements = document.querySelectorAll('.vs__search');
        elements[elements.length - 1].focus();
      }, 100);

    },
    limpiarAdd() {
      this.articulosAddMore = [
        {
          image: '',
          sku: '',
          cantidad: '',
          fecha: ''
        }
      ];
    },
    guardarPendiente() {

      let datosEnviar = [];

      this.articulosAddMore.forEach(item => {

        let finalizado = false;
        let sku = item.sku.sku;

        if (item.sku.shopify_product_id == -1) {
          finalizado = true;
          sku = item.titulo;
        }

        if (item.sku != '' && item.cantidad != '') {
          const today = new Date();
          let fecha = "";
          if (item.fecha == "")
            fecha = today.toISOString().split('T')[0];
          else
            fecha = item.fecha;

          datosEnviar.push({
            sku: sku,
            cantidad: item.cantidad,
            titulo: sku,
            fechaTerminado: fecha,
            finalizado: finalizado,
            product: item.sku
          })
        }

      });

      this.articulosAddMore = [
        {
          image: '',
          sku: '',
          cantidad: '',
          fecha: ''
        }];

      axios
        .post("/finanzas/pendiente/multiple/facturar", datosEnviar)
        .then(response => {
          return response.data;
        })
        .then(res => {

          let idNext = res.insertId;

          datosEnviar.forEach(item => {
            item.id = idNext;
            item.check = false;
            item.image = item.product.image;
            item.finalizado = false;

            let skuCortado = item.sku.replace(/-[^-]+$/, "");

            if (item.sku.includes('CLOTH-BAG'))
              skuCortado = item.sku;

            const articuloEncontrado = this.articulosSku.filter(item => item.sku === skuCortado);

            if (articuloEncontrado.length > 0) {
              if (articuloEncontrado[0].confeccion == 0 && articuloEncontrado[0].ubrique != 0)
                item.total = articuloEncontrado[0].ubrique * item.cantidad;
              else
                item.total = articuloEncontrado[0].confeccion * item.cantidad;

              item.total = parseFloat(item.total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
            }

            this.listadoPendiente.unshift(item);

            idNext++;
          });

          this.$bvModal.hide('modal-add');

          this.buscarFuncion(this.listadoPendiente);

          this.$swal({
            icon: 'success',
            title: 'Completado',
            text: 'Se han agregado correctamente los productos.',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })

        });

    },
    guardarPediente() {

      if (this.inputSku != null) {
        let finalizado = false;
        let sku = this.inputSku.sku;

        if (this.inputSku.shopify_product_id == -1) {
          finalizado = true;
          sku = this.inputTitulo;
        }

        if (sku == '' || this.inputCantidad == '')
          return;

        let data = {
          sku: sku,
          cantidad: this.inputCantidad,
          titulo: sku,
          fechaTerminado: this.inputFecha,
          finalizado: finalizado
        }

        axios
          .post("/finanzas/pendiente/facturar", data)
          .then(response => {
            return response.data;
          })
          .then(res => {

            data.id = res.insertId;
            data.check = false;
            data.image = this.inputSku.image;
            data.finalizado = false;
            this.listadoPendiente.unshift(data);

            this.$bvModal.hide('modal-add');

            this.inputSku = null;
            this.inputCantidad = "";
            this.inputTitulo = "";
            this.inputFecha = "";

            this.buscarFuncion(this.listadoPendiente);

            this.$swal({
              icon: 'success',
              title: data.sku,
              text: 'Se ha agregado correctamente.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          });
      }
    },
    cargarColumnas() {
      this.columnasTable = [];

      this.columnasAll.forEach(column => {
        this.columnasTable.push(column);
      });
    },
    editarPrecios() {
      this.$router.push('/precios-sku');
    },
    selectAll() {
      //this.listadoPendiente
      this.articulosBusqueda.forEach(element => {
        element.check = true;
      });
      this.$refs.table.refresh();
    },
    copiarSelect() {

      var csv = "SKU;Fecha;Cantidad;Precio\n";

      this.articulosBusqueda.forEach(item => {
        let totalItem = "";

        if (item.total != undefined)
          totalItem = item.total;

        csv += item.sku + ";" + item.fechaTerminado + ";" + item.cantidad + ";" + totalItem + "\n";
      });

      navigator.clipboard.writeText(csv);

      this.$swal({
        icon: 'success',
        title: 'Productos copiados.',
        text: '',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      });


      /*var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", 'data:text/csv;charset=utf-8,'+encodedUri);
      link.setAttribute("download", "sku_precios.csv");
      document.body.appendChild(link); 
      link.click();*/
    },
    editandoCantidad(data) {
      data.editando = true;
      this.$refs.table.refresh();
    },
    guardarCantidad(data) {
      data.editando = false;
      this.$refs.table.refresh();

      if (data.check) this.calcularPrecios();

      axios
        .put("/finanzas/pendiente/facturar", data)
        .then(response => {
          return response.data;
        })
        .then(res => {

          this.$swal({
            icon: 'success',
            title: data.sku,
            text: 'Se ha modificado la cantidad correctamente.',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        });

    },
    getStockProduccion(item) {
      let aux = item.prevision - item.stock;
      if (aux <= 0)
        aux = "";
      return aux;
    },
    loadMore() {
      this.countItemView += this.nextScrollItemView;
      this.buscarFuncion();
    },
    togglePicker(data) {
      this.itemSelect = data.item;
    },
    rowClick(data) {
      this.itemSelect = data;
    },
    sortChanged(e) {
      this.lastSort = e;
      this.buscarFuncion();
    },
    facturarProductos() {
      let ids = [];

      this.listadoPendiente.forEach(item => {
        if (item.check)
          ids.push(item);
      });

      this.$router.push({ name: 'factura-edit', params: { parametro: ids } });
    },
    pedirCodigo() {
      this.$swal({
        title: 'Introducir codigo.',
        input: 'text',

        showCloseButton: true,
        inputValidator: (value) => {

          if (!value) {
          }
          else {
            this.facturarProductosManual(value);
          }
        }
      })

    },
    facturarProductosManual(codigo) {
      let ids = [];

      this.listadoPendiente.forEach(item => {
        if (item.check) {
          item.factura = codigo;
          item.fecha = '';
          item.finalizado = 1;
          ids.push(item);
        }

      });

      axios
        .post("/finanzas/pendiente/finalizar", ids)
        .then(response => {
          return response.data;
        })
        .then(res => {
          this.buscarFuncion();
        });

      //let datos = {factura: codigo, fecha:'', lista: ids};

    },
    itemCheck() {
      this.calcularPrecios();
    },
    calcularPrecios() {
      let contador = 0;
      let total = 0;

      const skuMap = new Map();
      for (const item of this.articulosSku) {
        if (!skuMap.has(item.sku)) skuMap.set(item.sku, item);
      }

      this.listadoPendiente.forEach(articulo => {
        if (articulo.check) {
          contador++;

          let skuCortado = articulo.sku.replace(/-[^-]+$/, "");

          if (articulo.sku.includes('CLOTH-BAG'))
            skuCortado = articulo.sku;

          const articuloEncontrado = skuMap.get(skuCortado);

          if (articuloEncontrado) {
            total += articuloEncontrado.confeccion * articulo.cantidad;
          }
          else {
            if ((skuCortado.split('-').pop() == 'NOMAD') || (skuCortado.split('-').pop() == 'DOPP')) {
              let skuCortadoNomadDop = skuCortado.replace(/-[^-]+$/, "");

              const articuloEncontradoNomad = skuMap.get(skuCortadoNomadDop);
              if (articuloEncontradoNomad) {
                total += articuloEncontradoNomad.confeccion * articulo.cantidad;
              }

            }
          }
        }

      });

      this.cantidadCheck = contador;
      this.totalCheck = parseFloat(total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
      //this.totalCheck = total;

    },
    deleteProducto() {

      let ids = [];

      this.listadoPendiente.forEach(item => {
        if (item.check)
          ids.push(item.id);
      });

      axios
        .delete("/finanzas/pendiente/facturar", { data: ids })
        .then(response => {
          return response.data;
        })
        .then(res => {

          this.listadoPendiente = this.listadoPendiente.filter(elemento => !ids.includes(elemento.id));

          this.articulosBusqueda = this.articulosBusqueda.filter(elemento => !ids.includes(elemento.id));

          this.buscarFuncion();
        });
    },
    buscarFuncion(items = this.listadoPendiente) {
      //let auxSorting = JSON.parse(JSON.stringify(items));
      let auxSorting = items;

      if (this.lastSort != null) {
        if (this.lastSort.sortDesc)
          auxSorting.sort((a, b) => b[this.lastSort.sortBy] - a[this.lastSort.sortBy]);
        else
          auxSorting.sort((a, b) => a[this.lastSort.sortBy] - b[this.lastSort.sortBy]);

        if (this.lastSort.sortBy == "sku") {
          if (this.lastSort.sortDesc)
            auxSorting.sort((a, b) => b.sku.localeCompare(a.sku))
          else
            auxSorting.sort((a, b) => a.sku.localeCompare(b.sku))
        }

      }

      items = auxSorting;

      if (!this.agruparCheck) {
        // if (!this.pedienteCheck)
        //   items = items.filter(item => !item.finalizado);
        // else
        //   items = items.filter(item => item.finalizado);
      }

      if(this.estadoSelect == 'Pendiente'){
        items = items.filter(item => !item.finalizado);

      }
      else if(this.estadoSelect == 'Facturado'){
        items = items.filter(item => item.finalizado);
      }      

      if (this.anyoSelect.value != "Todos") {
        items = items.filter(item => item.fechaTerminado.includes(this.anyoSelect.value));
      }

      items = items.filter(item => {

        const fechaDesdeCondicion = !this.fechaDesdeSelect || new Date(item.fechaTerminado) >= new Date(this.fechaDesdeSelect);
        const fechaHastaCondicion = !this.fechaHastaSelect || new Date(item.fechaTerminado) <= new Date(this.fechaHastaSelect);

        return fechaDesdeCondicion && fechaHastaCondicion;

      });

      this.articulosBusqueda = [];

      if (this.buscar == "") {
        this.articulosBusqueda = items;
      }
      else {
        let articulosEncontrado = [];
        items.forEach(articulo => {
          if (articulo.sku.toLowerCase().includes(this.buscar.toLowerCase())) {
            articulosEncontrado.push(articulo);
          }
        });

        this.articulosBusqueda = articulosEncontrado;
      }

      if (this.agruparCheck) {
        let auxArray = JSON.parse(JSON.stringify(this.articulosBusqueda))
          .filter(objeto => objeto.finalizado === 0);

        const arrayAgrupado = auxArray.reduce((resultado, objeto) => {
          // Verificar si ya existe una entrada para ese SKU
          const existeEntrada = resultado.find(item => item.sku === objeto.sku);

          if (existeEntrada && existeEntrada.finalizado == 0) {
            // Convertir cantidad y total a números si son válidos
            const cantidad = parseFloat(objeto.cantidad);
            const total = parseFloat(objeto.total);

            // Si la cantidad es válida, sumarla
            if (!isNaN(cantidad)) {
              existeEntrada.cantidad += cantidad;
            }

            // Si el total es válido, sumarlo
            if (!isNaN(total)) {
              existeEntrada.total = parseFloat(existeEntrada.total) + total;
            }

            // Si el total es NaN, establecerlo como vacío o algún valor por defecto
            if (isNaN(existeEntrada.total)) {
              existeEntrada.total = '';
            }
          } else {
            // Si no existe, agregar una nueva entrada
            resultado.push({
              ...objeto,
              cantidad: parseFloat(objeto.cantidad) || 0, // Validar cantidad al agregar
              total: parseFloat(objeto.total) || 0 // Validar total al agregar
            });
          }

          return resultado;
        }, []);

        this.articulosBusqueda = arrayAgrupado;


      }

      if (this.articulosBusqueda.length > this.countItemView) {
        this.articulosBusqueda = this.articulosBusqueda.slice(0, this.countItemView);
      }

      //agruparCheck
    },
    recalcularDatos() {
      this.cargarColumnas();

      this.buscarFuncion();
    },
    seleccionarTodos() {

      this.articulosBusqueda.forEach(item => {
        item.check = true;
      });

      this.calcularPrecios();

      this.$refs.table.refresh();

    },
    limpiarSeleccionados() {

      this.articulosBusqueda.forEach(item => {
        item.check = false;
      });

      this.calcularPrecios();

      this.$refs.table.refresh();
    }
  },
  mounted() {
    this.loadItems();
  },
  watch: {
    buscar() {
      if (this.buscar == "")
        this.countItemView = this.defaultItemView;
      this.buscarFuncion();
    },
    agruparCheck() {
      this.buscarFuncion();
    },
    meses: {
      handler(newValue, oldValue) {
        if (this.watching)
          this.recalcularDatos();
      },
      deep: true
    },
    anyos: {
      handler(newValue, oldValue) {
        if (this.watching)
          this.recalcularDatos();
      },
      deep: true
    },
    empresaSelect() {
      this.countItemView = this.defaultItemView;
      //this.recalcularDatos();
    },
    anyoSelect() {
      this.countItemView = this.defaultItemView;
      this.buscarFuncion();
    },
    pedienteCheck() {
      this.buscarFuncion();
    },
    estadoSelect() {
      this.buscarFuncion();
    },
    fechaDesdeSelect() {
      this.buscarFuncion();
    },
    fechaHastaSelect() {
      this.buscarFuncion();
    }
  }
}
</script>

<style lang="scss">
@import '../@core/scss/vue/libs/chart-apex.scss';
@import '../@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style scoped>
/* ═══ Layout ═══ */
.alb {
  padding: 0;
}

.alb__main {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ═══ Toolbar ═══ */
.alb__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 14px;
  padding: 14px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.alb__toolbar-left,
.alb__toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.alb__toolbar-title {
  font-size: 16px;
  font-weight: 700;
  color: #3b4253;
  display: flex;
  align-items: center;
  gap: 8px;
}

.alb__toolbar-title i {
  color: #7367f0;
}

/* ═══ Botones ═══ */
.alb__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.alb__btn--primary {
  background: #7367f0;
  color: #fff;
}
.alb__btn--primary:hover {
  background: #5e50ee;
  box-shadow: 0 4px 12px rgba(115, 103, 240, 0.35);
}

.alb__btn--secondary {
  background: #f4f5f7;
  color: #5e5873;
}
.alb__btn--secondary:hover {
  background: #e8e6f0;
}

.alb__btn--success {
  background: #28c76f;
  color: #fff;
}
.alb__btn--success:hover {
  background: #1fa85c;
  box-shadow: 0 4px 12px rgba(40, 199, 111, 0.35);
}

.alb__btn--danger {
  background: #ea5455;
  color: #fff;
}
.alb__btn--danger:hover {
  background: #d63031;
  box-shadow: 0 4px 12px rgba(234, 84, 85, 0.35);
}

.alb__btn--danger-outline {
  background: transparent;
  color: #ea5455;
  border: 1px solid #ea5455;
}
.alb__btn--danger-outline:hover {
  background: #ea5455;
  color: #fff;
}

.alb__btn--outline {
  background: transparent;
  color: #7367f0;
  border: 1px solid #7367f0;
}
.alb__btn--outline:hover {
  background: #7367f0;
  color: #fff;
}

.alb__btn-fab {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #28c76f 0%, #48da89 100%);
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(40, 199, 111, 0.4);
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alb__btn-fab:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(40, 199, 111, 0.5);
}

.alb__btn-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s;
}

.alb__btn-icon--primary {
  background: #eeedfd;
  color: #7367f0;
}
.alb__btn-icon--primary:hover {
  background: #7367f0;
  color: #fff;
}

.alb__btn-icon--warning {
  background: #fff3e0;
  color: #ff9f43;
}
.alb__btn-icon--warning:hover {
  background: #ff9f43;
  color: #fff;
}

.alb__btn-icon--danger {
  background: #fce4e4;
  color: #ea5455;
}
.alb__btn-icon--danger:hover {
  background: #ea5455;
  color: #fff;
}

/* ═══ Filtros ═══ */
.alb__filters {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  background: #fff;
  border-radius: 14px;
  padding: 16px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}

.alb__filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
}

.alb__filter-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8a8e99;
  margin-bottom: 0;
}

.alb__filter-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-bottom: 2px;
}

.alb__filter-toggle {
  margin-left: auto;
  padding-bottom: 2px;
}

.alb__date-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
}

.alb__date-clear {
  background: none;
  border: none;
  color: #b0b5c0;
  cursor: pointer;
  font-size: 13px;
  padding: 4px;
  transition: color 0.2s;
}
.alb__date-clear:hover {
  color: #ea5455;
}

/* ═══ Barra de seleccion ═══ */
.alb__selection-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #eeedfd 0%, #f5f3ff 100%);
  border: 1px solid #d6d2f8;
  border-radius: 14px;
  padding: 12px 20px;
  animation: alb-slide-in 0.25s ease;
}

@keyframes alb-slide-in {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}

.alb__selection-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #5e5873;
}

.alb__selection-badge {
  background: #7367f0;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  padding: 2px 10px;
  border-radius: 20px;
  min-width: 28px;
  text-align: center;
}

.alb__selection-total {
  font-weight: 700;
  color: #28c76f;
  font-size: 15px;
  margin-left: 4px;
}

.alb__selection-actions {
  display: flex;
  gap: 8px;
}

/* ═══ Buscador ═══ */
.alb__search {
  position: relative;
}

.alb__search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #b0b5c0;
  font-size: 14px;
  z-index: 1;
}

.alb__search-input {
  width: 100%;
  padding: 12px 16px 12px 42px;
  border: 1px solid #e9ecf1;
  border-radius: 14px;
  font-size: 14px;
  color: #3b4253;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.2s;
  outline: none;
}

.alb__search-input:focus {
  border-color: #7367f0;
  box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.12);
}

.alb__search-input::placeholder {
  color: #c0c4cc;
}

/* ═══ Tabla ═══ */
.alb__table-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: visible;
}

.alb__sku {
  color: #7367f0;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.15s;
}
.alb__sku:hover {
  color: #5e50ee;
  text-decoration: underline;
}

.alb__img {
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #eee;
}

.alb__img--lg {
  width: 80px;
  height: 80px;
}

.alb__cantidad {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  padding: 4px 10px;
  background: #f4f5f7;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  margin: 0;
}
.alb__cantidad:hover {
  background: #eeedfd;
  color: #7367f0;
}

.alb__cantidad-edit {
  display: flex;
  align-items: center;
  gap: 6px;
}

.alb__cantidad-input {
  width: 50px;
  padding: 4px 8px;
  border: 1px solid #7367f0;
  border-radius: 8px;
  text-align: center;
  font-size: 13px;
  outline: none;
}

.alb__cantidad-save {
  background: #28c76f;
  color: #fff;
  border: none;
  border-radius: 8px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}
.alb__cantidad-save:hover {
  background: #1fa85c;
}

/* Badges estado */
.alb__badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.alb__badge--facturado {
  background: #e8fce8;
  color: #28a745;
}

.alb__badge--pendiente {
  background: #fff3e0;
  color: #ff9f43;
}

/* ═══ Footer modo agregar ═══ */
.alb__add-actions {
  text-align: center;
  padding: 14px;
}

.alb__add-footer {
  text-align: center;
  padding: 16px;
  border-top: 1px solid #f0f1f4;
}

.alb__bottom-bar {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 8px 0;
}
</style>

<style lang="scss">
/* Estilos globales para tabla y modal */
.alb__table {
  margin-bottom: 0;

  thead th {
    background: #f8f9fb !important;
    border-bottom: 2px solid #e9ecf1 !important;
    border-top: none !important;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #8a8e99;
    padding: 12px 14px;
    white-space: nowrap;
  }

  tbody td {
    padding: 10px 14px;
    vertical-align: middle;
    border-bottom: 1px solid #f0f1f4 !important;
    border-top: none !important;
    font-size: 13px;
    color: #5e5873;
  }

  tbody tr {
    transition: background 0.15s;
    background: transparent !important;

    &:hover {
      background: #f9f8ff !important;
    }
  }

  &.b-table-striped tbody tr:nth-of-type(odd) {
    background: transparent !important;
  }
}

.alb__modal .modal-content {
  border-radius: 16px;
  border: none;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.12);
}

.alb__modal .modal-header {
  border-bottom: 1px solid #f0f1f4;
  padding: 16px 20px;
}

.alb__modal .modal-title {
  font-weight: 700;
  color: #3b4253;
}

.alb__modal .modal-body {
  padding: 20px;
}

.dark-layout {
  .alb__toolbar,
  .alb__filters,
  .alb__table-card,
  .alb__search-input {
    background: #242424;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  }

  .alb__toolbar-title {
    color: #d0d2d6;
  }

  .alb__search-input {
    border-color: #333;
    color: #d0d2d6;

    &::placeholder {
      color: #676d7d;
    }
  }

  .alb__filter-label {
    color: #b4b7bd;
  }

  .alb__selection-bar {
    background: linear-gradient(135deg, #242424 0%, #2e2e2e 100%);
    border-color: #333;
  }

  .alb__selection-info {
    color: #d0d2d6;
  }

  .alb__btn--secondary {
    background: #333;
    color: #d0d2d6;
  }

  .alb__btn--outline {
    border-color: #7367f0;
    color: #7367f0;
  }

  .alb__table {
    thead th {
      background: #2e2e2e !important;
      border-bottom-color: #333 !important;
      color: #b4b7bd;
    }

    tbody td {
      color: #d0d2d6;
      border-bottom-color: #333 !important;
    }

    tbody tr {
      background: transparent !important;

      &:hover {
        background: #2e2e2e !important;
      }
    }
  }

  .alb__cantidad {
    background: #333;
    color: #d0d2d6;

    &:hover {
      background: #2e2e2e;
      color: #7367f0;
    }
  }

  .alb__badge--pendiente {
    background: #3a2e1e;
    color: #ff9f43;
  }

  .alb__badge--facturado {
    background: #1e3a2a;
    color: #28a745;
  }

  .alb__add-footer {
    border-top-color: #333;
  }

  .alb__modal .modal-content {
    background: #242424;
  }

  .alb__modal .modal-header {
    border-bottom-color: #333;
  }

  .alb__modal .modal-title {
    color: #d0d2d6;
  }
}
</style>